export default __webpack_public_path__ + "static/media/performance.72ddaafc.PNG";